import React from 'react';

import Layout from '../components/Layout';

const NotFound = () => {

    return (
        <Layout>
            <div className="main-wrapper">
                <section>
                    <h2 className="mb-12">AudioEngine Gateway</h2>
                    <h4>Page Not Found</h4>
                    <p>
                        Return to the home screen and access the left sidebar navigation.
                    </p>
                </section>
            </div>
        </Layout>
    );
};

export default NotFound;
